var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "header-bottom__mobile flex w-1-4 items-center justify-end whitespace-no-wrap"
    },
    [
      _vm.cartQty
        ? _c(
            "router-link",
            {
              attrs: {
                tag: "div",
                to: { name: "cart", params: { id: _vm.cart.id } }
              }
            },
            [
              _c("icon-cart", {
                staticClass: "text-brand",
                attrs: { qty: _vm.cartQty }
              })
            ],
            1
          )
        : [
            _vm.isWhitelabel
              ? _c(
                  "router-link",
                  {
                    staticClass:
                      "text-lg text-brand-secondary mr-_5 cursor-pointer",
                    attrs: {
                      tabindex: "0",
                      tag: "div",
                      to: { name: "trackOrder" }
                    }
                  },
                  [_vm._v("Track")]
                )
              : [
                  _vm.userLoggedIn
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-lg text-brand-secondary mr-_5 cursor-pointer",
                          attrs: { tabindex: "0" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("log-out")
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.$emit("log-out")
                            }
                          }
                        },
                        [_vm._v("Sign Out")]
                      )
                    : _c(
                        "router-link",
                        {
                          staticClass:
                            "text-lg text-brand-secondary mr-_5 cursor-pointer",
                          attrs: {
                            tabindex: "0",
                            tag: "div",
                            to: { name: "signIn" }
                          }
                        },
                        [_vm._v("Sign In")]
                      )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }